<div class="wo-account-title">
  <iss-avatar
    [username]="name"
    class="wo-account-title-avatar"
  ></iss-avatar>
  <div>
    <div class="wo-account-title-main">
      <div>{{ name }}</div>
    </div>
    <div class="wo-account-title-roles">
      <tui-tag
        *ngFor="let role of roles"
        size="s"
        [value]="role | capitalize"
        [autoColor]="true"
      />
    </div>
  </div>
</div>
